var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 8C10.2105 8 12.0005 6.21 12.0005 4C12.0005 1.79 10.2105 0 8.00049 0C5.79049 0 4.00049 1.79 4.00049 4C4.00049 6.21 5.79049 8 8.00049 8ZM8.00049 10C5.33049 10 0.000488281 11.34 0.000488281 14V15C0.000488281 15.55 0.450488 16 1.00049 16H15.0005C15.5505 16 16.0005 15.55 16.0005 15V14C16.0005 11.34 10.6705 10 8.00049 10Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/Details.a343a2af7b2c224935852ac08c39dbc5.svg";
export { ForwardRef as ReactComponent };